import { VARIANTS } from '@components/ArtBoard/Node/constants'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import cx from 'classnames'
import type React from 'react'
import { memo } from 'react'
import { useSelector } from 'react-redux'

import { DEFAULT_PAGE_NAME } from '@/constants/defaultNames'
import { Blocks } from './components/Blocks'
import css from './Node.module.scss'

type Props = {
  nodeId: string
}

const Node: React.FC<Props> = ({ nodeId }) => {
  const node = useSelector(migrationProjectSelector.getProjectNodeById(nodeId))
  const colorHex = useSelector(
    migrationProjectSelector.getProjectNodeColorHex(nodeId)
  )
  const childIdsLength = useSelector(
    migrationProjectSelector.getProjectNodeChildIdsLength(nodeId)
  )

  const { title: name, variant } = node

  const isProjectNeutral = useSelector(
    migrationProjectSelector.getIsProjectNeutral
  )

  const isProjectMobile = useSelector(
    migrationProjectSelector.getIsProjectMobile
  )

  const isNeutral = useSelector(migrationProjectSelector.getIsProjectNeutral)

  const nodeStyles = {
    '--node-color': colorHex,
  } as React.CSSProperties

  return (
    <div
      className={cx(css.container, {
        [css.ghost]: variant === VARIANTS.GHOST,
        [css.mobile]: isProjectMobile,
      })}
      style={nodeStyles}
    >
      {variant === VARIANTS.STACK && <div className={css.stackGhost} />}

      <div
        className={cx(css.node, {
          'node--mobile': isProjectMobile,

          [css.mobile]: isProjectMobile,

          // variants
          [css.page]: variant === VARIANTS.DEFAULT,
          [css.dashed]: variant === VARIANTS.FRAME,
          [css.stack]: variant === VARIANTS.STACK,
        })}
      >
        {(variant === VARIANTS.DEFAULT || variant === VARIANTS.STACK) &&
          !isProjectNeutral && (
            <div className={css.handler}>
              <div />
              <div />
              <div />
            </div>
          )}
        <div
          className={cx(css.name, {
            [css.dashed]: variant === VARIANTS.FRAME,
            [css.neutral]: isNeutral,
          })}
        >
          <div>{name === ' ' ? '\u00A0' : name || DEFAULT_PAGE_NAME}</div>
        </div>
        <div className={css.blocks}>
          <Blocks nodeId={nodeId} />
        </div>
        {childIdsLength > 0 && (
          <div className={css.subPages}>
            {childIdsLength} {childIdsLength === 1 ? 'page' : 'pages'}
          </div>
        )}
      </div>
    </div>
  )
}

export default memo(Node)
